"use strict";

define('rs/modals/upload/upload.view',['e3-modal', 'evisions/evimenu/evimenu', 'evisions/uuid'], function (E3Modal, EVIMenu, prefixUuid) {
  var UploadView = E3Modal.SectionView.extend({
    modalClassName: 'upload-modal modal-lg',
    className: '',
    events: {
      'click .remove-queued-file': 'handleRemoveQueuedFile',
      'click .remove-file': 'handleRemoveFile',
      'click .add-link-btn': 'handleLinkUrl',
      'click .cancel-link-btn': 'hideLinkForm',
      'keydown .add-link-btn': 'handleAddLinkKeydown',
      'keydown .cancel-link-btn': 'handleCancelLinkKeydown',
      'keypress .url-input': 'handleURLKeypress',
      'click .start-upload-btn': 'handleStartUploadClick'
    },
    templates: {
      'upload.modal': 'renderInitFragment',
      'hidden.fileinput': 'renderHiddenFileInputFragment',
      'upload.item': 'renderUploadFragment',
      'upload.error': 'renderErrorFragment'
    },
    render: function render() {
      var properties = this.getDelegate().getTemplateProperties();
      var view = this.getDelegate().getModal().getView();
      this.$el.html(this.renderInitFragment(properties));
      view.$el.find(".modal-header button.close").attr({
        "role": "button",
        "aria-label": "close"
      });
      view.$el.find(".modal-header button.close i").removeClass().addClass("remove icon white");
      view.$el.find(".modal-dialog").attr({
        "aria-label": "Documents",
        "role": "dialog"
      });
      this.refreshAddBtn();
      this.setupFileDrop();
    },
    refreshAddBtn: function refreshAddBtn() {
      var delegate = this.getDelegate(),
        view = delegate.getModal().getView(),
        btn = delegate.buttons[0];
      if (delegate.canAddMore()) {
        btn.disabled = false;
        btn.title = 'Add a document';
      } else {
        btn.disabled = true;
        btn.title = 'You cannot add more than one document';
      }
      view.refreshFooter();
    },
    showLinkForm: function showLinkForm() {
      this.getLinkForm().slideDown();
    },
    hideLinkForm: function hideLinkForm() {
      return Promise.resolve(this.getLinkForm().slideUp().promise());
    },
    clearLinkForm: function clearLinkForm() {
      var form = this.getLinkForm();
      url = form.find('[data-property="url"]').val('');
      displayName = form.find('[data-property="displayName"]').val('');
    },
    refreshFileInstructions: function refreshFileInstructions() {
      var delegate = this.getDelegate();
      if (delegate.getFiles().length + delegate.getUploadQueue().length > 0) {
        this.$('.file-instructions').hide();
      } else {
        this.$('.file-instructions').show();
      }
    },
    renderQueuedFile: function renderQueuedFile(file) {
      this.renderFile(file, this.getQueuedFileContainer());
    },
    removeQueuedFile: function removeQueuedFile(file) {
      this.removeFileById(file.uuid, this.getQueuedFileContainer());
    },
    renderFile: function renderFile(file, container) {
      (container instanceof $ ? container : this.getFileContainer()).append(this.renderUploadFragment(file, true));
    },
    renderLink: function renderLink(file) {
      this.renderFile(file, this.getLinkContainer());
    },
    removeLink: function removeLink(file) {
      this.removeFileById(file.uuid, this.getLinkContainer());
    },
    removeFile: function removeFile(file) {
      this.removeFileById(file.uuid);
    },
    hideFileContainer: function hideFileContainer() {
      this.getFileContainer().hide();
    },
    showFileContainer: function showFileContainer() {
      this.getFileContainer().show();
    },
    showLinkContainer: function showLinkContainer() {
      this.getLinkContainer().show();
    },
    hideLinkContainer: function hideLinkContainer() {
      this.getLinkContainer().hide();
    },
    showUploadQueue: function showUploadQueue(animate) {
      this.getQueuedFileContainer().show();
    },
    hideUploadQueue: function hideUploadQueue(animate) {
      this.getQueuedFileContainer().hide();
    },
    removeFileById: function removeFileById(id, container) {
      return this.getFileById(id, container).remove();
    },
    getFileById: function getFileById(id, container) {
      return (container || this.getFileContainer()).find('.file-item[data-uuid="' + id + '"]');
    },
    getFileContainer: function getFileContainer() {
      return this.$('.file-container');
    },
    getLinkContainer: function getLinkContainer() {
      return this.$('.link-container');
    },
    getDropzone: function getDropzone() {
      return this.$('.file-dropzone');
    },
    getQueuedFileContainer: function getQueuedFileContainer() {
      return this.$('.queued-file-container');
    },
    getQueuedFileTable: function getQueuedFileTable() {
      return this.$('.queued-file-table');
    },
    getLinkForm: function getLinkForm() {
      return this.$('.add-link-form');
    },
    getLinkData: function getLinkData() {
      var form = this.getLinkForm(),
        properties = form.getProperties();
      return {
        displayName: properties.displayName || properties.url,
        url: properties.url,
        link: true,
        uuid: prefixUuid('link')
      };
    },
    processNativeFile: function processNativeFile(file) {
      var delegate = this.getDelegate();
      if (file) {
        delegate.addFileForUpload({
          uuid: prefixUuid('upload'),
          file: file,
          name: file.name,
          queued: true
        });
      }
    },
    hoveringFilesHasChanged: function hoveringFilesHasChanged(over) {
      var dropzone = this.getDropzone();
      if (over && this._previouslyOver !== over) {
        dropzone.slideDown();
      } else if (!over && this._previouslyOver !== over) {
        dropzone.slideUp();
      }
      this._previouslyOver = over;
    },
    setupFileDrop: function setupFileDrop() {
      var that = this;
      var hover = function hover(over) {
        that.hoveringFilesHasChanged(over);
      };
      var drop = function drop(files) {
        _.each(files, that.processNativeFile, that);
      };
      this._hoverHandler = hover;
      this._dropHandler = drop;
      FileAPI.event.dnd(document.body, hover, drop);
    },
    updateFileProgress: function updateFileProgress(file, progress) {
      var fileById = this.getFileById(file.uuid, this.getQueuedFileContainer());
      if (fileById) {
        fileById.find('.file-progress').css('width', progress * 100 + '%');
      }
    },
    fileUploadDidFail: function fileUploadDidFail(file, error) {
      var el = this.getFileById(file.uuid, this.getQueuedFileContainer()).addClass('failed').removeClass('uploading');
      if (error && error.getServerMessage) {
        el.append('<div class="upload-error-message red-font-color" role="alert">Error: ' + error.getServerMessage() + '</div>');
      }
    },
    fileDidStartUploading: function fileDidStartUploading(file) {
      var el = this.getFileById(file.uuid, this.getQueuedFileContainer());
      el.addClass('uploading');
    },
    setupHiddenFileInput: function setupHiddenFileInput() {
      var input = $('.upload-add-file-menu .hidden-file-upload'),
        that = this,
        delegate = this.getDelegate();
      FileAPI.event.one(input.get(0), 'change', function (ev) {
        var files = FileAPI.getFiles(ev);
        _.each(files, that.processNativeFile, that);
        EVIMenu.hide();
      });
    },
    handleAddAction: function handleAddAction(ev) {
      var el = $(ev.currentTarget),
        that = this;
      EVIMenu.show({
        element: el,
        className: 'upload-add-file-menu rs-menu',
        template: 'upload.submenu.item',
        horizontal: 'right',
        container: $(".modal-dialog"),
        caret: 'top-left',
        noHide: true,
        offset: {
          left: 28
        }
      }, [{
        name: 'Add Link'
      }, {
        name: 'Add File',
        multiple: this.getDelegate().getMultiple(),
        hiddenInput: true
      }]).bind(this).then(function (obj) {
        switch (obj.index) {
          case 0:
            EVIMenu.hide();
            this.showLinkForm();
            break;
          case 1:
            if (obj.item) obj.item.find("ul li input").click();
            break;
        }
      }).caught(function (e) {
        EVIMenu.hide();
        throw e;
      });
      _.defer(_.bind(this.setupHiddenFileInput, this));
    },
    enableClose: function enableClose() {
      var modal = this.getDelegate().getModal(),
        footer = modal.getView().getFooterElement();
      footer.find('.btn').removeClass('disabled');
      this.delegateEvents();
      this.$('.url-input').attr('disabled', false);
      this.$('.hidden-file-upload').attr('disabled', false);
      modal.getView().$el.on('click.dismiss.modal', '[data-dismiss="modal"]', function () {
        modal.close();
      });
    },
    disableClose: function disableClose() {
      var modal = this.getDelegate().getModal(),
        footer = modal.getView().getFooterElement();
      footer.find('.btn').addClass('disabled');
      this.undelegateEvents();
      this.$('.url-input').attr('disabled', true);
      this.$('.hidden-file-upload').attr('disabled', true);
      modal.getView().$el.off('click.dismiss.modal');
    },
    handleRemoveQueuedFile: function handleRemoveQueuedFile(ev) {
      var fileRow = $(ev.currentTarget).closest('.file-item'),
        uuid = fileRow.data('uuid');
      if (uuid) {
        this.getDelegate().removeUploadById(uuid);
      }
    },
    handleRemoveFile: function handleRemoveFile(ev) {
      var fileRow = $(ev.currentTarget).closest('.file-item'),
        uuid = fileRow.data('uuid');
      if (uuid) {
        this.getDelegate().removeFileById(uuid);
      }
    },
    addLinkInfo: function addLinkInfo() {
      var links = $(this.el).find('a');
      links.each(function () {
        var url = $(this).attr('href');
        if (url) {
          $(this).attr({
            "title": url,
            "aria-label": $(this).text() + ": "
          });
        }
      });
    },
    handleLinkUrl: function handleLinkUrl() {
      this.getDelegate().requestAddLink();
      var that = this;
      setTimeout(function () {
        that.addLinkInfo();
      }, 100);
    },
    handleAddLinkKeydown: function handleAddLinkKeydown(event) {
      if (["Enter", " "].includes(event.key)) {
        this.handleLinkUrl();
      }
    },
    handleCancelLinkKeydown: function handleCancelLinkKeydown(event) {
      if (["Enter", " "].includes(event.key)) {
        this.hideLinkForm();
      }
    },
    handleApplyAction: function handleApplyAction() {
      this.getDelegate().requestApply().bind(this);
    },
    destroy: function destroy() {
      FileAPI.event.dnd.off(document.body, this._hoverHandler, this._dropHandler);
      this._super.apply(this, arguments);
    }
  });
  return UploadView;
});

